import React, {Component} from 'react';
import '../App.css';
  

import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import Spinner from 'react-bootstrap/Spinner'

class IdCardLogin extends Component {

    constructor() {
        super();
    
        this.refEmployeeIdNum = React.createRef();
        this.refEmployeeCardNum = React.createRef();
      }

    state = {    
        codeOverSms:true,
        EmployeeCardNum:'',
        EmployeeIdNum:'',
        errorMsg:''
    }

    
    setEmployeeCardNum = (val) =>  {        
        this.setState({EmployeeCardNum:val});  
    } 

    setEmployeeIdNum = (val) =>  {        
        this.setState({EmployeeIdNum:val});  
    } 

    keyPressEmployeeIdNum = (event) =>  {        
        if (event.key == 'Enter')  {
            this.refEmployeeCardNum.current.focus();
        }
    } 
    
    keyPressEmployeeCardNum = (event) =>  {        
        if (event.key == 'Enter')  {
            this.doLogin();
        }
    } 

    doLogin = () => {

        if(this.props.loading)
            return;

        console.log('IdCardLogin doLogin clicked');

        //work.
        let data = {};
        data.employeeCardNum = this.state.EmployeeCardNum;
        data.employeeIdNum = this.state.EmployeeIdNum;
        data.codeOverSms = this.state.codeOverSms;

        if (data.employeeCardNum.length == 0 || data.employeeIdNum.length == 0)
        {
            this.setState({ errorMsg: 'יש להזין נתונים.' }); 
            return;
        }

        this.props.doLogin(data);
    }

    isCodeOverSms = ()  => {
        if (this.state.codeOverSms) {
            return true;
        }
        return false;
    }

    toggleCodeOverSms = ()  => {        
        const b = this.state.codeOverSms;
        this.setState({ codeOverSms: !b });                
    }

    render() {     
    
        let errorMsg = this.props.errorMsg;
        if (errorMsg == '') {
            errorMsg = this.state.errorMsg;
        }
        return (     
                <React.Fragment>

                    <div className="hp_loginField_container">                 
                        <div className="cntered-flex" >  
                            <div> 
                        

                        
                                <div className="hp_search_field_container hp_search_field_marginRight15">                
                                    <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                                    ת.ז.</span>              
                                    <div className="hp_search_field_titleLogin loginUser">
                                        <input type="text"  
                                            className="loginUser" 
                                            maxLength="9"
                                            placeholder="ת.ז."
                                            onChange={e => this.setEmployeeIdNum(e.target.value)}
                                            onKeyPress={this.keyPressEmployeeIdNum} 
                                            ref={this.refEmployeeIdNum} />
                                    </div>
                                </div>

                                <div className="hp_search_field_container hp_search_field_marginRight15 marginTop14">                
                                    <span className="hp_search_field_dropDown_inner_placeBox_title_small">
                                    משתמש</span>              
                                    <div className="hp_search_field_titleLogin loginUser">
                                        <input type="text"  
                                            className="loginUser" 
                                            maxLength="6"
                                            placeholder="4 ספרות אחרונות על גב הכרטיס"
                                            onChange={e => this.setEmployeeCardNum(e.target.value)}
                                            onKeyPress={this.keyPressEmployeeCardNum}  
                                            ref={this.refEmployeeCardNum} />
                                    </div>
                                </div>
                                

                                <div className="login_note marginTop10">
                                    <div className="login_note marginRight15">
                                        בחר מבין האפשרויות
                                    </div>


                                    <div className="login_check_wrapper marginRight15" 
                                        onClick={() => this.toggleCodeOverSms()} >
                                                                           
                                        { (this.isCodeOverSms()) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                        <span className="login_check_title"> קוד במסרון</span>
                                        
                                    </div>

                                    <div className="login_check_wrapper marginRight15" 
                                     onClick={() => this.toggleCodeOverSms()} >
                                                                           
                                        { (!this.isCodeOverSms()) ?
                                            <img src={"./images/site/components/checked.png"} alt=""/>
                                        : 
                                            <img src={"./images/site/components/unchecked.png"} alt=""/>
                                        }
                                        <span className="login_check_title">קוד במייל </span>
                                        
                                    </div>
                                </div>

                                <div className="cntered-flex hp_login_box_msgPanel"> 
                                    <div >{errorMsg}</div>
                                </div>  
                            </div> 

                        </div>
                    </div>
                    


                    {(this.props.loading) ?
                    <React.Fragment>
                        <div className="cntered-flex directionRtl marginBottom10">
                        מבצע כניסה למערכת ...
                        <Spinner
                            as="span"
                            animation="border"

                            role="status"
                            aria-hidden="true"                                        
                        />      
                        </div>
                        </React.Fragment>
                    : null}



                    <div className="cntered-flex ">
                        <div className="hp_search_main_button"
                                onClick={() => this.doLogin()}>
                            <span className="hp_search_main_button_title">
                            שלח קוד כניסה
                            </span>
                        </div>
                    </div>




                </React.Fragment>
            
        )
    }
}


export default compose(
    withNofeshService()
  )(IdCardLogin);


